export default __webpack_public_path__ + "images/loyalty-reward-icon.1f1fdf26.svg";